export function centerActiveLink() {
	const wrap = document.querySelector("[data-category-menu]");
	if (!wrap) return;

	const activeLink = wrap.querySelector(".category-menu__link.active");
	if (!activeLink) return;

	requestAnimationFrame(() => centerActive(wrap, activeLink));

	window.addEventListener("resize", () => centerActive(wrap, activeLink), { passive: true });

	function centerActive(wrapper, el) {
		const wrapperRect = wrapper.getBoundingClientRect();
		const elRect = el.getBoundingClientRect();

		const current = wrapper.scrollLeft;

		const elCenter = elRect.left - wrapperRect.left + current + elRect.width / 2;

		const target = Math.max(0, elCenter - wrapper.clientWidth / 2);

		wrapper.scrollTo({ left: target });
	}
}
